import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import React from "react";
import CreateTrip from "src/views/manage-trip/CreateTrip";

const SinglAssignTrip = ({
  selectedModalBookingoOrderId,
  setSelectedModalBookingoOrderId,
}) => {
  return (
    <CModal
      backdrop="static"
      alignment="center"
      size="xl"
      visible={!!selectedModalBookingoOrderId}
      onClose={() => setSelectedModalBookingoOrderId(null)}
      aria-labelledby="StaticBackdropExampleLabel"
    >
      <CModalHeader>
        <CModalTitle id="StaticBackdropExampleLabel">
          Create New Trip
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CreateTrip id={selectedModalBookingoOrderId} />
      </CModalBody>
    </CModal>
  );
};

export default SinglAssignTrip;
